import { create } from "zustand";
import { useCampaignType, useRoleType } from "./type";
import HttpService from "./Api/interceptors";
import { AxiosResponse } from "axios";

export const useCampaign = create<useCampaignType>((set) => ({
  campaign: [],
  setCampaign: (value) => set(() => ({ campaign: value })),
}));

export const useRole = create<useRoleType>((set) => ({
  isFetching: true,
  isMonitor: false,
  checkIsMonitor: async () => {
    set(() => ({ isFetching: true }));
    await HttpService.get("/api/users/is-monitor")
      .then((resp: AxiosResponse) => {
        set(() => ({ isMonitor: resp?.data?.isMonitor || false }));
        set(() => ({ isFetching: false }));
      })
      .catch(() => {
        set(() => ({ isMonitor: false }));
        set(() => ({ isFetching: false }));
      });
  },
  setIsMonitor: (value) => set(() => ({ isMonitor: value })),
}));
